function share(social, subject) {
    var winTop = (screen.height / 2) - (350 / 2);
    var winLeft = (screen.width / 2) - (520 / 2);
    var url =window.location.href;

    if (social == "facebook") {
        window.open('http://www.facebook.com/sharer.php?u=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
    }
    if (social == "linkedin") {
        window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
    }
    if (social == "twitter") {
        window.open('https://twitter.com/share?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
    }
    if (social == "doximity") {
        window.open('https://www.doximity.com/inbox/conversations/new_message?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
    }
    if (social == "email") {
        window.location.href = "mailto:?Subject=" + subject + "&Body=" + url;
    }
}
